// React import
import * as React from 'react'
// Standard layout imports
import Label from 'src/components/FormElements/Label';
import Button from 'src/components/Button';
import Box from 'src/components/Box';
import { IActivityThemeModel } from 'src/Entities/ActivityTheme/ActivityTheme';
import { IActivityCategoryModel } from 'src/Entities/ActivityCategory/ActivityCategory';
import Checkbox from 'src/components/FormElements/Checkbox';
import Icon from 'src/components/Icon';

interface IProps {
    onTopicSave: (categoryId: string[]) => void;
    userInterests: string[];
    categories: IActivityCategoryModel[];
    themes: IActivityThemeModel[];    
    didSave: boolean
}
interface IState{
    checkedCategaries: string[];
    
}
class MyPageUserInterests extends React.Component<IProps, IState>{
    /**
     *
     */
    constructor(props: any) {
        super(props);
        this.state = { checkedCategaries:this.props.userInterests  ? this.props.userInterests  : new Array()}
        this.onSave = this.onSave.bind(this);
        this.onTopicChange = this.onTopicChange.bind(this);
        
    }

    public onTopicChange(event: any){
        
        if(event.target.checked){
            this.props.userInterests.push(event.target.id)
            this.setState({checkedCategaries: this.props.userInterests})
        }
        else{
            // const newarr = this.props.userInterests.filter(ui => ui !== event.target.id)
            this.props.userInterests.splice(this.props.userInterests.indexOf(event.target.id),1)
            this.setState({checkedCategaries: this.props.userInterests})
        }
               
        
    }

    public onSave(e?:any){
        
        this.props.onTopicSave(this.props.userInterests);
        // this.props.onTopicSave(this.state.categoriesToSave)
        e.preventDefault()
    }

    public render() {
        // save the true checkboxes to component state.

        return (
        <div>            
            <Box className="mb2">
                {this.props.themes.map(t => (
                    <div key={t.themeId} className="mb1">
                        <Label className="f4 b">{t.name}</Label>
                        
                        <div className="label" style={{display:"flex", flexWrap:"wrap"}}>
                        {this.props.categories.filter(c => 
                            c.themeId.toString() === t.themeId.toString())
                            .map((cat) => 
                                (
                                    <div key={cat.categoryId} style={{flex: "1 0 40%"}}>
                                        <Checkbox inline={true}  checked={this.state.checkedCategaries.indexOf(cat.categoryId.toString())>=0}  onChange={this.onTopicChange} className="mr4" name="checkbox" id={cat.categoryId.toString()}>
                                            {cat.name} 
                                        </Checkbox>
                                        </div>
                                ))
                        }
                        </div>
                    </div>
                    )
                    )}
            </Box>
            <div className="tr">
                {this.props.didSave? <div>ændringerne er gemt</div> : null}   <Button onClick={this.onSave}>GEM <Icon name="chevron-right" /></Button>
            </div>
        </div>
        )
    }
}

export default MyPageUserInterests


// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/MyPage/myPageUserInterests.component.tsx